import "./OccupancyForecast.css";
import { InfoTooltip } from "./InfoTooltip";

export interface ForecastPeriod {
  periodNumber: number;
  periodLabel: string;
  inventory: number;
  occupancyPct: number;
  attritionPct: number;
  bookedDays: number;
  actualDays: number;
}

interface OccupancyForecastProps {
  fiscalYear: string;
  asOfDate?: string;
  tooltipText?: string;
  periods: ForecastPeriod[];
}

export function OccupancyForecast({
  fiscalYear,
  asOfDate,
  tooltipText,
  periods,
}: OccupancyForecastProps) {
  // The API appends a fiscal-year rollup row as period 0; it renders as the trailing Totals column.
  const totals = periods.find((p) => p.periodNumber === 0);
  const periodColumns = periods.filter((p) => p.periodNumber !== 0);

  return (
    <div className="forecastWrap">
      <section className="forecastCard" aria-labelledby="forecast-heading">
        <h2 id="forecast-heading" className="forecastTitle">
          <span>DU Occupancy Forecast</span>
          {tooltipText && <InfoTooltip text={tooltipText} placement="bottom" renderInPortal />}
        </h2>

        <div className="tableWrap">
         
          <table className="forecastTable">
            <thead>
              <tr style={{ borderBottom: "1px solid #A7A8AA", height: "35px" }}>
                <th scope="col" style={{ width: "190px" }}>{fiscalYear}</th>
                {periodColumns.map((p) => (
                  <th key={p.periodNumber} scope="col">
                    <span className="periodName">Period {p.periodNumber}</span>
                    <span className="periodDate">{p.periodLabel}</span>
                  </th>
                ))}
                {totals && (
                  <th scope="col" className="totalsCol">
                    <span className="periodName">Totals</span>
                    <span className="periodDate">&nbsp;</span>
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              <tr className="metricInventory" style={{ borderBottom: "1px solid #A7A8AA", height: "30px" }}>
                <th scope="row" >
                  Inventory
                </th>
                {periodColumns.map((p) => (
                  <td key={p.periodNumber}>{p.inventory.toLocaleString()}</td>
                ))}
                {totals && <td className="totalsCol">{totals.inventory.toLocaleString()}</td>}
              </tr>
              <tr className="metricOccupancy" style={{ borderBottom: "1px solid #A7A8AA" , height: "35px"}}>
                <th scope="row">
                  Occupancy %
                  <span className="metricNote">Based on inventory</span>
                </th>
                {periodColumns.map((p) => (
                  <td key={p.periodNumber}>{p.occupancyPct.toFixed(2)}%</td>
                ))}
                {totals && <td className="totalsCol">{totals.occupancyPct.toFixed(2)}%</td>}
              </tr>
              <tr className="metricAttrition" style={{ borderBottom: "1px solid #A7A8AA", height: "35px" }}>
                <th scope="row">
                  Attrition %
                  <span className="metricNote">Based on actuals</span>
                </th>
                {periodColumns.map((p) => (
                  <td key={p.periodNumber}>{p.attritionPct.toFixed(2)}%</td>
                ))}
                {totals && <td className="totalsCol">{totals.attritionPct.toFixed(2)}%</td>}
              </tr>
              <tr style={{ height: "35px"}}>
                <th scope="row">
                  Booked / actual days
                </th>
                {periodColumns.map((p) => (
                  <td key={p.periodNumber}>
                    {p.bookedDays.toLocaleString()}
                     {/* /{" "}
                    {p.actualDays.toLocaleString()} */}
                  </td>
                ))}
                {totals && <td className="totalsCol">{totals.bookedDays.toLocaleString()}</td>}
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
